import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
  getPhpApiUrl,
} from "./ServiceHelper";
import { getLocations, getEthnicities } from "./LookupService";
import moment from "moment";
import { getAccessToken, getLoggedInUser } from "./AuthenticationService";
import i18n from "../i18n";
import { USER_LANG } from "../actions/constant";

export function signUp(user) {
  return fetch(getApiUrl() + "/users", {
    method: "POST",
    headers: getHeaderForAjax(),
    body: JSON.stringify(user),
  })
    .then(checkStatus)
    .then(parseJSON);
}
function tzmUpdate(tzmLocal, id) {
  return fetch(getApiUrl() + "/users/" + id + "/timezone/" + tzmLocal, {
    method: "PUT",
    headers: getHeaderForAjax(),
  });
}
export async function getUser(id) {
  const changesLang = await localStorage.getItem("ChangeLang");

  if (changesLang && changesLang != null) {
    await langUpdate(id, changesLang);
  }
  let tzmLocal = moment().utcOffset();
  let tzmServer = 0;
  return fetch(getApiUrl() + "/users/" + id, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      localStorage.setItem("user", JSON.stringify(responseData));
      let langList = USER_LANG;
      localStorage.removeItem("ChangeLang");
      langList.map((item) => {
        if (item.value == responseData.lang) {
          if (i18n.language != item.code) {
            if (changesLang) {
              try {
              } catch (error) {
                console.log(error);
              }
            } else {
              if (item.code) {
                i18n.locale = item.code;
                localStorage.setItem("ChangeLang", item.value);
                localStorage.setItem("i18nextLng", item.code);
                sessionStorage.setItem("i18nextLng", item.code);
              }
              window.location.reload();
            }
          }
        }
      });
      //update tzm
      if (responseData.tzm) {
        tzmServer = responseData.tzm;
      }
      if (tzmServer !== tzmLocal) {
        tzmUpdate(tzmLocal, id);
      }
      // end
      return responseData;
    })
    .catch((err) => {
      console.log("fetch error" + err);
    });
}

export function getSubUser(userId, subUserId) {
  return fetch(getApiUrl() + "/users/" + userId + "/subusers/" + subUserId, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function getNotifyNum() {
  let userId = await getLoggedInUser();
  let totalitems = 0;
  return fetch(getApiUrl() + "/users/" + userId._id + "/inboxstatus", {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      // if (responseData.totalitems) {
      //   totalitems = responseData.totalitems;
      // }
      // localStorage.setItem("notifyNum", responseData.totalitems);

      return responseData.totalitems;
    })
    .catch((err) => {
      console.log("fetch error" + err);
    });
}
// inbox num
export async function getInboxNum() {
  let userId = await getLoggedInUser();
  let totalitems = 0;
  return fetch(getApiUrl() + "/users/" + userId._id + "/message/count", {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      // if (responseData.data) {
      //   totalitems = responseData.totalitems;
      // }
      // localStorage.setItem("notifyNum", responseData.totalitems);
      return responseData.data;
    })
    .catch((err) => {
      console.log("fetch error" + err);
    });
}

/**
 * this function is called from the function getUserWithMainUserAndSubUsers
 * @param {string} id Main User's ID
 */
export function getSubUsers(id) {
  return fetch(getApiUrl() + "/users/" + id + "/subusers", {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(function (err) {
      // put a catch here
      // because we still need to return the process
      // even if it was a Promise.all
      // because the API
      // returns a status of 404 if the Main User
      // doesn't have a Sub User
      // ( the default structure for a new user is really without a sub user )
      console.log("UserService::getSubUsers(), Error:" + err);
    });
}

/**
 * This function will return values to profileReducer::reducer()switch case getSucceeded(PROFILE_GET_USER_AND_SUBUSERS):
 * @param {String} id the current active user's ID
 * @param {String} mainId the main user's ID
 */
export function getUserWithMainUserAndSubUsers(id, mainId) {
  return Promise.all([getUser(mainId), id, getSubUsers(mainId)]);
}

export function updateProfile(user) {
  return fetch(getApiUrl() + "/users/" + user._id, {
    method: "PUT",
    headers: getHeaderForAjax(),
    body: JSON.stringify(user),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function createSubUser(userId, subUser) {
  if (subUser.group == "1100") {
    if (!subUser.ethnicity) {
      subUser.ethnicity = [];
    }
  } else {
    subUser.ethnicity = [];
  }
  return fetch(getApiUrl() + "/users/" + userId + "/subusers", {
    method: "POST",
    headers: getHeaderForAjax(),
    body: JSON.stringify(subUser),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function updateSubUser(userId, subUser) {
  return fetch(getApiUrl() + "/users/" + userId + "/subusers/" + subUser._id, {
    method: "PUT",
    headers: getHeaderForAjax(),
    body: JSON.stringify(subUser),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function updateUserAndSubuser(MainUser, subUser) {
  if (MainUser._id === subUser._id) {
    var data = Promise.all([updateProfile(subUser)]);
  } else {
    var data = Promise.all([updateSubUser(MainUser._id, subUser)]);
  }
  return data;
}

export function formUpdateInitialization(mainId, userId) {
  return Promise.all([
    mainId === userId ? getUser(userId) : getSubUser(mainId, userId),
    getLocations(),
    getEthnicities(),
    userId,
  ]);
}
export function deleteSubUser(userId, subUserId, password) {
  return fetch(
    getApiUrl() +
    "/users/" +
    userId +
    "/subusers/" +
    subUserId +
    "/" +
    password,
    {
      method: "DELETE",
      headers: getHeaderForAjax(),
    }
  )
    .then(checkStatus)
    .then(() => ({ deletedId: subUserId }));
}

export function deleteUser(userId, password) {
  return fetch(getApiUrl() + "/users/" + userId + "/" + password, {
    method: "DELETE",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(() => ({ deletedId: userId }));
}

export async function loginRequired(props) {
  let isItThere = "";
  isItThere = localStorage.getItem("user");
  if (isItThere && isItThere.length > 0) {
    return true;
  } else {
    window.location = "/";
    // props.history.push("/");
    return false;
  }
}
export function graduateUser(mainUser, email, password, subUserID) {
  let body = {
    email: email,
    password: password,
  };
  return fetch(
    getApiUrl() + "/users/" + mainUser + "/subusers/" + subUserID + "/graduate",
    {
      method: "PUT",
      headers: getHeaderForAjax(),
      body: JSON.stringify(body),
    }
  )
    .then(checkStatus)
    .then(parseJSON);
}
export function langUpdate(id, lang) {
  let body = {
    user: id,
    lang: lang,
  };
  let url = getPhpApiUrl() + "/user/updateLang";
  return fetch(url, {
    method: "PUT",
    headers: new Headers({
      "Content-Type": "application/json",
      token: getAccessToken(),
      user: getLoggedInUser()._id,
    }),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/UserService.js